import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    SALES_SELECT_CAT: 'SALES_SELECT_CAT',
};

export const actions = {
    setSalesSelectedCat: (obj) => utils.action(types.SALES_SELECT_CAT, obj),
};

const initialState = fromJS({
    data: {
        currentPage: 1,
        dropdownData: [],
        dropdownDataLoaded: false,
        loaded: false,
        searchString: '',
        selectedCategory: 'all-options',
    },
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.SALES_SELECT_CAT:
        if (action.payload) {
            return fromJS({
                data: action.payload,
            });
        }

        break;
    default:
        return state;
    }
};

const getSalesSelectedCat = (state) => state.get('app').get('salesSelectedCat');

export const selectors = {
    getSalesSelectedCat: getSalesSelectedCat,
};
